export class Room {
    id: number;
    name: string;
    description: string;
    capacity: number;
    withTV: boolean;
    withWhiteBoard: boolean;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/room.ts